export enum actions {
  SET_RECOMMENDATION_CATALOG_ACTIVE_CHIP = 'SET_RECOMMENDATION_CATALOG_ACTIVE_CHIP'
}

export const RECOMMENDATIONS_REQUEST_LIMIT = 10;
export const RECOMMENDATIONS_CATALOG_NUMBER_OF_ROWS = 2;
